import { Form, FormResponseValue } from "@tellescope/types-models";
import { TellescopeFormFieldBaseProps } from "../../types";
import { StripeFieldContent } from "./StripeFieldContent";

export interface StripeFieldProps extends TellescopeFormFieldBaseProps<"Stripe"> {
  enduserId: string;
  form: Form;
  formResponses: FormResponseValue[];
}

export const StripeField = ({ title, ...rest }: StripeFieldProps) => {
  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <StripeFieldContent {...rest} />
    </div>
  );
};
